/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import accordion from '../accordion/locale.js';
import breadcrumbs from '../breadcrumbs/locale.js';
import datepicker from '../datepicker/locale.js';
import datatable from '../data-table/locale.js';
import buttongroup from '../button-group/locale.js';
import fileuploader from '../file-uploader/locale.js';
import menu from '../menu/locale.js';
import modal from '../modal/locale.js';
import drawer from '../drawer/locale.js';
import pagination from '../pagination/locale.js';
import select from '../select/locale.js';
import toast from '../toast/locale.js';
var en_US = {
  accordion: accordion,
  breadcrumbs: breadcrumbs,
  datepicker: datepicker,
  datatable: datatable,
  buttongroup: buttongroup,
  fileuploader: fileuploader,
  menu: menu,
  modal: modal,
  drawer: drawer,
  pagination: pagination,
  select: select,
  toast: toast
};
export default en_US;